import { memo, useMemo } from 'react';
import { Box, Text } from '@betty/moonlight';
import { StatusInstructionsProps } from './types';
import StatusMemberInstructions from './StatusMemberInstructions';
import StatusVipInstructions from './StatusVipInstructions';
import StatusInstruction from './StatusInstruction';

function StatusInstructions({ status }: StatusInstructionsProps) {
  const content = useMemo(() => {
    switch (status.playerStatus) {
      case 'Member':
        return <StatusMemberInstructions status={status} />;
      case 'Vip':
        return <StatusVipInstructions />;
      default:
        return (
          <>
            <StatusInstruction
              totalBoxes={status.keepStatusNumberOfBoxes as number}
              claimedBoxes={status.claimedBoxesCount as number}
              variant="stay"
              statusName={status.playerStatus}
            />
            {status.nextPlayerStatus && (
              <>
                {/* <Separator> */}
                <Box position="relative" justifyContent="center">
                  <Box
                    position="absolute"
                    absoluteFill
                    paddingVertical="space-300"
                    backgroundColor="mutedBackground"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Box
                      width="space-025"
                      flex={1}
                      backgroundColor="washedBackground"
                    />
                  </Box>
                  <Box
                    backgroundColor="mutedBackground"
                    paddingVertical="space-200"
                  >
                    <Text
                      locNS="status"
                      locKey="status_instructions_separator"
                      variant="caption-semi"
                      color="darkSurfaceWashed"
                    />
                  </Box>
                </Box>
                {/* </Separator> */}
                <StatusInstruction
                  totalBoxes={status.promotionNumberOfBoxes as number}
                  claimedBoxes={status.claimedBoxesCount as number}
                  variant="upgrade"
                  statusName={status.nextPlayerStatus}
                />
              </>
            )}
          </>
        );
    }
  }, [status]);

  return (
    <Box
      flexDirection="row"
      justifyContent="center"
      alignItems="stretch"
      borderRadius="radius-200"
      backgroundColor="mutedBackground"
    >
      {content}
    </Box>
  );
}

export default memo(StatusInstructions);
